const root = "Button-module_root_RSLKls-N";
const buttonStyles = {
  root
};
export {
  buttonStyles as default,
  root
};
